import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { Occurrence } from '@klopotun/contracts';
import { payOccurrence, type PayOccurrencePayload } from '../requests/pay-occurrence.js';
import { invalidateOccurrence } from './occurrence-cache.js';

export type PayOccurrenceInput = { id: string; body: PayOccurrencePayload };

/**
 * Confirming a payment and correcting an already confirmed one are the same route and the same
 * fields (design note C12), so the mini app has one mutation for both.
 */
export const usePayOccurrenceMutation = (): UseMutationResult<
  Occurrence,
  Error,
  PayOccurrenceInput
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: PayOccurrenceInput) => payOccurrence(input.id, input.body),
    onSuccess: (occurrence) => invalidateOccurrence(queryClient, occurrence),
  });
};
